<template>
  <div class="c-solidarity-projects">
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0017_samu-social-paris.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>为流落街头的女性提供容身之处</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>SAMUSOCIAL DE PARIS</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>Samusocial de Paris的存在宗旨，是为因病痛或贫困而流落巴黎街头的人提供帮助。基金会向Samusocial de Paris伸出援手，帮助其新建了一间专为女性开放的紧急收容所。该收容所的前身是一间弃用的医院，2011年寒冬到来时被紧急征用。如今，该不动产的所有者决定将其出售。新收容所的所在地毗邻旧址，位于Charles Foix医院院内，不仅方便提供医疗护理，而且交通便利。收容所配备面积宽敞的花园，环境静谧，可为遇到家庭或个人困难的女性提供休养空间。翻新工程不仅修复了主体建筑，还改善了收容所的居住和工作环境。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.samusocial.paris/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0016_ares.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>重返社會：針對脫離職場婦女的專案</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>經濟及社會回歸協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            「經濟及社會回歸」協會（ARES, Association pour la Réinsertion
            Economique et
            Sociale）是法國協助重新回歸社會者的主要參與機構之一，它在基金會的協助下推行了第一個針對婦女的計劃。
            ARES與處境穩定的婦女網絡建立新的合作夥伴關係，提供專門培訓並給予適當支持。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.groupeares.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0015_adie.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>女企業家</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>ADIE</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Adie藉由小額信貸，幫助缺乏職場和資金資源的人創業和創造工作機會。
            2015年，Sisley多納諾基金會協助了 Adie
            Saint-Denis（93省）分支機構，透過提供「Sisley榮譽女性」（Sisley
            Women of Honor）榮譽貸款，讓女性實現她們的創業計劃。
            2017年，基金會進一步發展與Adie的合作夥伴關係，資助Adie在瑟吉（Cergy，95省）建立新的分支機構，該機構的願景是成為支瓦勒德瓦茲（Val
            d’Oise）婦女的企業精神「地區指標」。
            這項為期三年的先導計劃將試驗協助女性企業家的新方法，以改善促進婦女回歸社會的方法。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.adie-fondsdedotation.org/actualites/ladie-ouvre-une-nouvelle-antenne-quartiers-cergy">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0014_aux-captifs-de-la-liberation.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>回歸社會：告別賣淫活動</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>從囚牢解放</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description"            >
          <p>
            在基金會的支持下，「從囚牢解放」（Aux Captifs la
            Liberation）在巴黎皮加勒（Pigalle）區開設了一個接待處，專門為人口販賣的女性受害者提供服務。
            該機構無條件接納婦女，並提供社會支持。
            成立於1981年的「從囚牢解放」協會，近距離接觸並協助處境極度困頓的人，尤其是人口販賣的女性受害者。
            協會的志工和員工一年四季持續在街頭接觸有困難的人，並為他們提供個人所需的幫助（醫療保險、最低社會保障、法律支持、住宿）。
            該協會並提供抽離居留和回歸社會的活動，旨在使人重新積極面對人生。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.captifs.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0013_lazare.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>居無定所者的家</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>LAZARE組織</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持Lazare組織，資助該組織在瓦茲省（Oise）的沃穆瓦斯（Vaumoise）鄉村之家的裝潢和設備，以及在南特（Nantes）建造個人住宿空間工作室。
            拉札爾之家（Maison
            Lazare）成立於2006年，為年輕人和無家可歸的人提供共居的空間。
            原則是讓被開除的人與25歲至35歲的年輕志願者共同生活。
            共居的原則是以友好和關懷為基礎，目的是幫助人們重拾自尊和重新社交。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://lazare.eu/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0012_asmae.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持弱勢兒童</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>ASMAE：以馬內利修女協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            由以馬內利（Emmanuelle）修女於1980年成立的Asmae協會以兒童處境為關注的重心。
            每天晚上，透過無家可歸熱線115而住宿到塞納-聖丹尼（Seine-Saint-Denis）旅館的人高達8600人。
            因此，ASMAE在2006年創建了一個接待中心，主要提供兩項服務：
            家長支持中心「蛹」（La
            Chrysalide）提供住宿給處境極不穩定，並有年幼兒女的年輕婦女，「兒童島」（Ile
            aux Enfants）則是該中心和市中心的托兒所。
            2017年以來，Asmae在Sisley-d'Ornano基金會的支持下，讓在塞納-聖丹尼（Seine-Saint-Denis）區透過無家可歸熱線115而入住旅館的家庭能夠使用托兒所的設施。
            該計劃的目的是支持在旅館房間中成長的幼兒的啟蒙和發展。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.asmae.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0011_josephine.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>使美麗成為融入社會的助力</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>約瑟芬協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            露西婭·伊拉奇（Lucia
            Iraci）於2006年以女性之美為主旨，創辦了「約瑟芬」（Joséphine）協會，致力使美麗成為促使每位女性在社會安身立命的助力。
            約瑟芬沙龍透過與其合作的社會人士，引導女性順利融入社會或職場。
            在約瑟芬美容之旅的過程中讓女性重拾自信，並且為未來做好準備。
            女性享受舒緩身心的時光，透過探索各式各樣的美容療程，重新尋回寵愛自己的樂趣，並且重獲自信，藉此在自己的職業生涯和/或社交生活邁進，目前已經有超過五千名女性受到款待。
            該協會受惠於Sisley多納諾基金會支持，透過將其團隊專業化來發展計劃。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www2.josephinebeaute.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0010_wake-up-cafe.jpg" class="m-foundation-content__image--primary lazyloaded" alt="基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>對抗出獄後再犯</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>WAKE UP CAFÉ協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持Wake Up
            Café協會幫助出獄後的更生人士重新適應社會，尤其特別針對被拘留婦女第一年重新融入社會的過程。
            自2014年以來，Wake Up
            Café協會長期協助在法國大巴黎地區的囚徒，從他們的監禁期到被企業夥伴聘用，一直到上任以後。
            透過持續追蹤個案，Wake Up
            Café協會根據個人情況調整協助方式，以讓更生人士能完整地重新適應，同時透過團體輔導，避免再次犯罪與孤獨感。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.wakeupcafe.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0009_claire-amitie.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>鼓勵新鮮人自主</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>法國克萊爾之友</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            基金會支持由「克萊爾之友」（Claire
            Amitié）協會在奧步（Aube）建立的創新計劃，透過組織更自主的生活空間（個人宿舍），提出收容替代方案，服務享有「年長青年」合約和受法國兒童社會福利援助的18到21歲的社會新鮮人。
            其理念是透過加速他們在被收容之際已經展開的自主過程，促進他們融入社會與職場，並且使他們成為自己人生的主人。
            「年長青年」計劃因此提出了一種更進一步的輔助，並且特別對於弱勢和曾被收容的民眾有所裨益。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.claireamitie.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0008_frederic-sausset.jpg" class="m-foundation-content__image--primary lazyloaded" alt="SIsley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>無障礙方向盤</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>弗雷德里克.索塞</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            弗雷德里克.索塞（Frédéric
            SAUSSET）車系推出的「無障礙方向盤」是全球首見由身障人士駕駛的國際一流車系，其目標是參與2020年勒蒙24小時耐力賽。
            這不僅關於運動成績，也具有高度的人權訴求，因為這使身障人士也能參與菁英賽事。
            Sisley多納諾基金會支持為期三年的耐力錦標賽訓練課程。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.srt41.com/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0007_le-ptit-cerny.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>埃松省的互助咖啡館</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>小塞爾尼</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會資助了「小塞爾尼」（Le P'tit
            Cerny）互助咖啡館，特別針對廚房設備的部分。
            此一咖啡館協會成立的宗旨是為塞爾尼（Cerny）城（位於南埃松省（Sud-Essonne）注入生氣，將不同的世代集結在一個聚會和構思計劃的據點。更重要的是，創造交流、談話與討論的機會，藉此驅散孤獨感。
            在該協會的200名成員中，約有50名現有成員參與經營計劃。
            為了令據點更熱鬧，大家都為這項計劃貢獻其經驗空閒時間、獨特的專才與想法，包括廚藝工作坊、對話空間、紀錄片討論、大眾作家、識字班、縫紉、編織、資訊科技、生態環境實踐、服裝改造及藝術家展場/工作坊。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://leptitcerny.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0006_j2p.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>為職場專業而設的社會語言學工作坊</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>J2P協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持J2P協會創建「摩媽行動」（Môm'action），這是為職場專業導向而提供的語言培訓。
            這項培訓結合了學齡前兒童、兒童及幼兒園老師等相關職業，針對因法文程度不足而難以融入社會與職場的18名女性移民。
            經過兩個系列的培訓課後，15名女性找到與兒童相關的職業，她們現在擔任幼兒園教師、保母、托兒所助理等。
            J2P協會的宗旨是促進巴黎第19區的Jaurès-Petit-Pantin的社會、經濟和文化之發展。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.associationj2p.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0005_kisany.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>通过刺绣培训，鼓励女性重掌生活控制权。</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>KISANY</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>KISANY LIVING LINENS是一个欧洲品牌，主要销售风格隽永、质量高端的家用纺织品和配饰，其产品全部产自东非。过去15年间，在比利时非盈利组织「En Avant les Enfants」的支持下，共有200位女裁缝师在戈马（刚果共和国）和基加利（卢旺达）获得了与此相关的培训。2017年，KISANY为100人提供了工作和收入。基金会自2013年起便投身于这个精彩的项目，并给予裁缝工坊鼎力支持。自2016年起，基金会开始将关注点转向儿童和年轻人，为其教育提供资金援助。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.kisany.com/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0004_zazakely.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>馬達加斯加的教育機會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>扎克利·桑巴特拉協會</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            「扎克利·桑巴特拉」（Zazakely
            Sambatra）協會是由維若妮卡·布爾吉（Véroniquede
            Bourgies）於2004年創建的協會，她在2015年11月13日的恐怖攻擊中不幸罹難。
            協會的目標是：使馬達加斯加的年輕人成為國家經濟發展的要員。
            Sisley多納諾基金會贊助該協會的全面教育陪伴計劃（教育、社會支持、健康衛教），針對最清貧民眾，尤其是位於距離塔那那利佛（Tananarive）20公里的馮托逢拉納（Vontovorana）的凱特撒（Ketsa）中心的年輕女孩。
            此計劃透過下列行動而推動：特別納入女性意識與性教育內容，並建立家庭計劃與生育前後的諮詢，來確保她們盡可能順利完成學業。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.zazakelysambatra.asso.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0003_sumba.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>消除营养不良计划，提供教育支持</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>SUMBA FOUNDATION</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>Sisley基金会为Sumba Foundation在印度尼西亚开展的两项行动提供了重要支持：其中一项为紧急粮食援助，以减轻儿童死亡率；另一项则是在校园内兴建饭堂，使学龄儿童每天都能获享均衡的饮食。在执行这些项目的过程中，基金会雇用岛上的居民作为员工，并与当地农民缔结合作关系。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://sumbafoundation.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0002_universite-automne-femmes-tunisiennes.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>创新行动计划</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>UNIVERSITÉ D'AUTOMNE DES FEMMES TUNISIENNES ET FRANÇAISES</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>在第二届「Université d'Automne des Femmes Tunisiennes et Françaises」举办之际，突尼斯女性Emna Miladi因「EcoElec项目」而获得了Sisley多纳诺基金会为其颁发的「女性成就奖」。该项目的宗旨是在非洲的偏远和落后地区安装光伏发电装置，以改善当地受缺电影响的教育现状。Sisley多纳诺基金会旨在为能够带来重要社会变化，并缔造价值的创新计划提供资金援助。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.femmes-debat-societe.com/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0001_anacaona.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>保護海地的環境和提高婦女地位</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>ANACAONA社區</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            ANACAONA社區是第一個在海地和加勒比海地區實施的肥皂回收計劃。
            此獨特計劃聚焦於三大問題：環境保護、減少水源傳播疾病和提高婦女地位。
            在海地的25家合作酒店的協助下，該組織每月收集一百公斤用過的肥皂。
            這些肥皂在該組織的工作室經過消毒和修復。
            一部分新肥皂免費提供給海地的弱勢社區，另一部分則結合當地素材而精製，然後在海外商店重新出售。
            得益於Sisley多納諾基金會的支持，ANACAONA於2017年遷入了新的辦公場所，使它能以永續發展的方式繼續經營。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.anacaona.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0000_jouons-pour-un-reve.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>體育：促進社會融合的教育手段</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>為夢想而戰</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            「為夢想而戰」（Jouons pour un
            rêve）協會將運動視為治療方式，讓來自（哥倫比亞卡利市）聖何塞（San
            José）孤兒院的年輕人能在團體中安身立命，締造社會連結，並為他們提供教育資源，以及身心的平衡發展。
            Sisley多納諾基金會資助購買裝備，並為聖何塞棒球隊提供教練培訓，這項集體的體育活動為這些兒童提供了指標，指導並陪伴他們往後的社會生活乃至職場生涯。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.jouonspourunreve.fr/">了解更多</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "FoundationSolidarity" };
</script>

<style lang="scss" scoped>
  .c-solidarity-content {
    padding-bottom: 4.8125rem;
    .c-solidarity-content__title-primary {
      font-size:.75rem;line-height:1.67;color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;padding-top:2.1875rem;
      p { margin-bottom:.3125rem; }
    }
    .c-solidarity-content__title-secondary {font-size:1.25rem;color:#000;font-family:PlayfairDisplay-Italic,arial,sans-serif;}
    .c-solidarity-content__description {font-size:.8125rem;line-height:1.62;color:#000;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;}
    .m-foundation-content__projects-title--third {z-index:2;font-weight:700;font-size:.75rem;text-decoration:underline;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;top:.625rem;}
    .m-minisite__description a { display: none; }
  }
  @media screen and (min-width:48em) {
    .c-solidarity-content { padding-bottom: 6.0625rem; }
  }
  @media screen and (min-width:64em) {
    .c-solidarity-content {
      padding-bottom: 8rem;
      .c-solidarity-content__title-primary { padding-top: 0; }
    }
  }
</style>